import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import Options from '../options/Options';

interface State {
	count: number;
	isWatchingUser: boolean;
	optionOn: boolean;
}

export class AtomCounter extends React.Component<{}, State> {

	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			count: 2,
			isWatchingUser: false,
			optionOn: Options.getCurrent().showAtomCounter,
		};

		document.body.addEventListener('watching-user', (e) => this.setState({ isWatchingUser: (e as CustomEvent).detail.isWatchingUser }));
		document.body.addEventListener('set-atom-count', (e) => this.setState({ count: (e as CustomEvent).detail.count }));
	}

	public render() {
		if (!this.state.optionOn || this.state.isWatchingUser) {
			return "";
		}

		return <div className="atom-counter">
			<button className='button' disabled={this.state.count == 1} onClick={() => this.incrementCounter(-1)}>
				<FontAwesomeIcon className='' icon={faMinus} />
			</button>
			<div className="atom-counter-count">
				{this.state.count}
			</div>
			<button className='button' disabled={this.state.count == 2} onClick={() => this.incrementCounter(1)}>
				<FontAwesomeIcon className='' icon={faPlus} />
			</button>
		</div>
	}

	incrementCounter(amount: number) {
		const newCount = this.state.count + amount;

		this.setState({ count: newCount });

		document.body.dispatchEvent(new CustomEvent("change-atom-count", { detail: { count: newCount } }))
	}
}